import React, { useState, useRef, useEffect } from "react";
import "./ChatScreen.css";
import api from '../api/Api';

export default function ChatPremium() {
  const [messages, setMessages] = useState([]);
  const [entidadeAtiva, setEntidadeAtiva] = useState(null);
  const [entidades, setEntidades] = useState([]);
  const [entidadesFiltradas, setEntidadesFiltradas] = useState([]);
  const userStored = JSON.parse(localStorage.getItem("user"));
  const [participantes, setParticipantes] = useState([]);
  const [participantesFiltrados, setParticipantesFiltrados] = useState([]);
  const [participantesNew, setParticipantesNew] = useState([]);
  const [participantesNewFiltrados, setParticipantesNewFiltrados] = useState([]);
  const [input, setInput] = useState("");
  const endRef = useRef(null);
  const [roleGrupo, setRoleGrupo] = useState(null);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
  const [newGroupDescricao, setNewGroupDescricao] = useState("");
  
  // Estados para os filtros
  const [filtroEntidades, setFiltroEntidades] = useState("");
  const [filtroMembros, setFiltroMembros] = useState("");
  const [filtroNovosMembros, setFiltroNovosMembros] = useState("");

  useEffect(() => {
    fetchEntidades();
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    // Filtrar entidades quando o filtro mudar
    if (filtroEntidades.trim() === "") {
      setEntidadesFiltradas(entidades);
    } else {
      const filtradas = entidades.filter(entidade =>
        entidade.nome.toLowerCase().includes(filtroEntidades.toLowerCase())
      );
      setEntidadesFiltradas(filtradas);
    }
  }, [entidades, filtroEntidades]);

  useEffect(() => {
    // Filtrar membros quando o filtro mudar
    if (filtroMembros.trim() === "") {
      setParticipantesFiltrados(participantes);
    } else {
      const filtradas = participantes.filter(participante =>
        participante.nome.toLowerCase().includes(filtroMembros.toLowerCase())
      );
      setParticipantesFiltrados(filtradas);
    }
  }, [participantes, filtroMembros]);

  useEffect(() => {
    // Filtrar novos membros quando o filtro mudar
    if (filtroNovosMembros.trim() === "") {
      setParticipantesNewFiltrados(participantesNew);
    } else {
      const filtradas = participantesNew.filter(participante =>
        participante.nome.toLowerCase().includes(filtroNovosMembros.toLowerCase())
      );
      setParticipantesNewFiltrados(filtradas);
    }
  }, [participantesNew, filtroNovosMembros]);

  const sendMessage = async () => {
    if (!input.trim()) return;
    if (!entidadeAtiva) return;

    // Verificar se é grupo e se o usuário não é admin
    if (entidadeAtiva.tipo === "grupo" && roleGrupo !== "ADMIN") {
      alert("Apenas administradores podem enviar mensagens no grupo.");
      return;
    }

    const texto = input;
    setInput("");

    try {
      if (entidadeAtiva.tipo === "usuario") {
        await handleAddMensagemPrivada(texto, entidadeAtiva.id);
      }

      if (entidadeAtiva.tipo === "grupo") {
        await handleAddMensagemGrupo(texto, entidadeAtiva.id);
      }
    } catch (error) {
      console.error("Erro ao enviar mensagem", error);
    }
  };

  const handleCreateGroup = async () => {
    if (!newGroupDescricao.trim()) {
      alert("Por favor, insira uma descrição para o grupo.");
      return;
    }

    try {
      const payload = {
        descricao: newGroupDescricao,
        id_criador: userStored.id
      };

      const resp = await api.AddGrupo(payload);

      if (resp?.success) {
        setNewGroupDescricao("");
        setShowCreateGroupModal(false);
        // Atualizar a lista de grupos
        fetchEntidades();
      } else {
        alert("Erro ao criar grupo.");
      }
    } catch (error) {
      console.error("Erro ao criar grupo", error);
      alert("Erro ao criar grupo.");
    }
  };

  const fetchParticipantes = async (idGrupo) => {
    try {
      const payload = { id_grupo: idGrupo };
      const response = await api.ListParticipanteGrupo(payload);
      
      if (Array.isArray(response)) {
        const dadosFormatados = response.map(item => ({
          nome: item.nome,
          id: item.id,    
        }));
        
        setParticipantes(dadosFormatados);
        setParticipantesFiltrados(dadosFormatados);
      }
    } catch (error) {
      console.error("Erro ao buscar chamadas:", error);
    }
  };

  const fetchParticipantesNew = async (idGrupo) => {
    try {
      const payload = { id_grupo: idGrupo };
      const response = await api.ListParticipanteGrupoNew(payload);
      
      if (Array.isArray(response)) {
        const dadosFormatados = response.map(item => ({
          nome: item.nome,
          id: item.id,    
        }));
        
        setParticipantesNew(dadosFormatados);
        setParticipantesNewFiltrados(dadosFormatados);
      }
    } catch (error) {
      console.error("Erro ao buscar chamadas:", error);
    }
  };

  const fetchRoleGrupo = async (idGrupo) => {
    try {
      const payload = {
        id_grupo: idGrupo,
        id_user: userStored.id
      };

      const response = await api.ListParticipante(payload);

      if (response?.role) {
        setRoleGrupo(response.role);
      } else {
        setRoleGrupo(null);
      }
    } catch (error) {
      console.error("Erro ao verificar role do grupo", error);
      setRoleGrupo(null);
    }
  };

  const fetchEntidades = async () => {
    try {
      const payload = { id: userStored.id };
      const response = await api.ListUserGrupo(payload);
      
      if (Array.isArray(response)) {
        const dadosFormatados = response.map(item => ({
          nome: item.nome,
          id: item.id,
          tipo: item.tipo,
        }));
        
        setEntidades(dadosFormatados);
        setEntidadesFiltradas(dadosFormatados);
      }
    } catch (error) {
      console.error("Erro ao buscar chamadas:", error);
    }
  };

  const handleAddMensagemPrivada = async (sms, idReceptor) => {
    const payload = {
      id_emissor: userStored.id,
      mensagem: sms,
      id_receptor: idReceptor
    };

    const resp = await api.AddMensagemPrivada(payload);

    if (resp?.success) {
      await fetchMensagemPrivada(idReceptor);
    }
  };

  const handleAddParticipante = async (idParticipante, idGrupo) => {
    if (roleGrupo !== "ADMIN") return;

    const payload = {
      id_grupo: idGrupo,
      id_user: idParticipante
    };

    const resp = await api.AddParticipante(payload);

    if (resp?.success) {
      await fetchParticipantes(idGrupo);
      await fetchParticipantesNew(idGrupo);
      // Resetar filtro após adicionar
      setFiltroNovosMembros("");
    }
  };

  const handleDeleteParticipante = async (idParticipante, idGrupo) => {
    if (roleGrupo !== "ADMIN") return;

    const payload = {
      id_grupo: idGrupo,
      id_user: idParticipante
    };

    const resp = await api.DeleteParticipante(payload);

    if (resp?.success) {
      await fetchParticipantes(idGrupo);
      await fetchParticipantesNew(idGrupo);
      // Resetar filtro após remover
      setFiltroMembros("");
    }
  };

  const handleAddMensagemGrupo = async (sms, idGrupo) => {
    const payload = {
      id_emissor: userStored.id,
      mensagem: sms,
      id_grupo: idGrupo
    };

    const resp = await api.AddMensagemGrupo(payload);

    if (resp?.success) {
      await fetchMensagemGrupo(idGrupo);
    }
  };

  const handleSelectEntidade = async (entidade) => {
    setEntidadeAtiva(entidade);
    setMessages([]);
    setRoleGrupo(null);
    // Resetar filtros ao selecionar nova entidade
    setFiltroMembros("");
    setFiltroNovosMembros("");

    if (entidade.tipo === "usuario") {
      fetchMensagemPrivada(entidade.id);
      return;
    }

    if (entidade.tipo === "grupo") {
      await fetchMensagemGrupo(entidade.id);
      await fetchRoleGrupo(entidade.id);
      await fetchParticipantes(entidade.id);
      await fetchParticipantesNew(entidade.id);
    }
  };

  function formatDateTime(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleString("pt-PT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  const fetchMensagemPrivada = async (idReceptor) => {
    try {
      const payload = { id_emissor: userStored.id, id_receptor: idReceptor };
      const response = await api.ListMensagemPrivada(payload);
      
      if (Array.isArray(response)) {
        const dadosFormatados = response.map(item => ({
          author: item.author,
          id: item.id,
          text: item.text,
          data: item.created_at
        }));
        
        setMessages(dadosFormatados);
      }
    } catch (error) {
      console.error("Erro ao buscar chamadas:", error);
    }
  };

  const fetchMensagemGrupo = async (idGrupo) => {
    try {
      const payload = { id_emissor: userStored.id, id_grupo: idGrupo };
      const response = await api.ListMensagemGrupo(payload);
      
      if (Array.isArray(response)) {
        const dadosFormatados = response.map(item => ({
          author: item.author,
          id: item.id,
          text: item.text,
          data: item.created_at
        }));
        
        setMessages(dadosFormatados);
      }
    } catch (error) {
      console.error("Erro ao buscar chamadas:", error);
    }
  };

  function getInitials(nome) {
    if (!nome) return "";
    const partes = nome.split(" ");
    return partes.length === 1
      ? partes[0][0]
      : partes[0][0] + partes[1][0];
  }

  // Função para limpar filtros
  const clearFilterEntidades = () => {
    setFiltroEntidades("");
  };

  const clearFilterMembros = () => {
    setFiltroMembros("");
  };

  const clearFilterNovosMembros = () => {
    setFiltroNovosMembros("");
  };

  return (
    <div className="chat-app">
      <aside className="chat-sidebar">
        <div className="sidebar-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1>Mensagens</h1>
            <button 
              className="create-group-btn"
              onClick={() => setShowCreateGroupModal(true)}
              title="Criar grupo"
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: '#007bff',
                color: 'white',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              +
            </button>
          </div>
          
          {/* Filtro para Entidades */}
          <div className="search-container">
            <div className="search-input-wrapper">
              <input
                type="text"
                placeholder="Pesquisar conversas..."
                value={filtroEntidades}
                onChange={(e) => setFiltroEntidades(e.target.value)}
                className="search-input"
              />
              {filtroEntidades && (
                <button 
                  className="clear-search-btn" 
                  onClick={clearFilterEntidades}
                  title="Limpar pesquisa"
                >
                  ✕
                </button>
              )}
            </div>
            {filtroEntidades && (
              <div className="search-info">
                {entidadesFiltradas.length} resultado{entidadesFiltradas.length !== 1 ? 's' : ''}
              </div>
            )}
          </div>
        </div>
        
        <div className="conversations-list">
          {entidadesFiltradas.length > 0 ? (
            entidadesFiltradas.map(entidade => (
              <div
                key={`${entidade.tipo}-${entidade.id}`}
                className={`chat-user ${
                  entidadeAtiva?.id === entidade.id &&
                  entidadeAtiva?.tipo === entidade.tipo
                    ? "active"
                    : ""
                }`}
                onClick={() => handleSelectEntidade(entidade)}
              >
                <div
                  className={`avatar ${
                    entidade.tipo === "grupo" ? "group" : "online"
                  }`}
                >
                  {getInitials(entidade.nome)}
                </div>
                <div className="user-name">
                  <strong>{entidade.nome}</strong>
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              {filtroEntidades ? "Nenhuma conversa encontrada" : "Nenhuma conversa disponível"}
            </div>
          )}
        </div>
      </aside>

      <main className="chat-main">
        <header className="chat-header">
          {entidadeAtiva ? (
            <div className="header-user">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div className={`avatar ${entidadeAtiva.tipo === "grupo" ? "group" : "online"}`}>
                  {getInitials(entidadeAtiva.nome)}
                </div>
                <div className="user-name-title">
                  <strong>{entidadeAtiva.nome}</strong>
                  {entidadeAtiva.tipo === "grupo" && roleGrupo === "ADMIN" && (
                    <span className="admin-badge"> (Administrador)</span>
                  )}
                </div>
              </div>
              
              {entidadeAtiva.tipo === "grupo" && roleGrupo === "ADMIN" && (
                <button
                  className="group-settings-btn"
                  onClick={() => setShowGroupModal(true)}
                  title="Gerir grupo"
                >
                  ⚙️
                </button>
              )}
            </div>
          ) : (
            <div className="no-chat-selected">
              <span>Selecione uma conversa</span>
            </div>
          )}
        </header>

        {/* Modal para criar grupo */}
        {showCreateGroupModal && (
          <div className="modal-overlay" onClick={() => setShowCreateGroupModal(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Criar novo grupo</h3>
                <button 
                  className="modal-close-btn"
                  onClick={() => setShowCreateGroupModal(false)}
                >
                  ✕
                </button>
              </div>
              <div className="modal-section">
                <input
                  type="text"
                  placeholder="Descrição do grupo"
                  value={newGroupDescricao}
                  onChange={(e) => setNewGroupDescricao(e.target.value)}
                  className="modal-input"
                  autoFocus
                />
              </div>
              <div className="modal-actions">
                <button className="secondary-btn" onClick={() => setShowCreateGroupModal(false)}>
                  Cancelar
                </button>
                <button className="primary-btn" onClick={handleCreateGroup}>
                  Criar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal para gerir grupo */}
        {showGroupModal && (
          <div className="modal-overlay" onClick={() => setShowGroupModal(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Gerir grupo</h3>
                <button 
                  className="modal-close-btn"
                  onClick={() => setShowGroupModal(false)}
                >
                  ✕
                </button>
              </div>

              {/* Seção de Membros com Filtro */}
              <div className="modal-section">
                <div className="section-header">
                  <h4 className="txt-classe">Membros ({participantes.length})</h4>
                  <div className="search-input-wrapper small">
                    <input
                      type="text"
                      placeholder="Pesquisar membros..."
                      value={filtroMembros}
                      onChange={(e) => setFiltroMembros(e.target.value)}
                      className="search-input"
                    />
                    {filtroMembros && (
                      <button 
                        className="clear-search-btn small" 
                        onClick={clearFilterMembros}
                        title="Limpar pesquisa"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
                
                <div className="modal-list">
                  {participantesFiltrados.length > 0 ? (
                    participantesFiltrados.map(p => (
                      <div key={p.id} className="modal-item">
                        <div className="modal-item-info">
                          <div className="avatar small">{getInitials(p.nome)}</div>
                          <span>{p.nome}</span>
                          {p.id === userStored.id && (
                            <span className="you-badge">(Você)</span>
                          )}
                        </div>
                        
                        {p.id !== userStored.id && (
                          <button
                            className="danger"
                            onClick={() =>
                              handleDeleteParticipante(p.id, entidadeAtiva.id)
                            }
                          >
                            Remover
                          </button>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="no-results-modal">
                      {filtroMembros ? "Nenhum membro encontrado" : "Nenhum membro"}
                    </div>
                  )}
                </div>
              </div>

              {/* Seção de Novos Membros com Filtro */}
              <div className="modal-section">
                <div className="section-header">
                  <h4 className="txt-classe">Novos ({participantesNew.length})</h4>
                  <div className="search-input-wrapper small">
                    <input
                      type="text"
                      placeholder="Pesquisar novos membros..."
                      value={filtroNovosMembros}
                      onChange={(e) => setFiltroNovosMembros(e.target.value)}
                      className="search-input"
                    />
                    {filtroNovosMembros && (
                      <button 
                        className="clear-search-btn small" 
                        onClick={clearFilterNovosMembros}
                        title="Limpar pesquisa"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
                
                <div className="modal-list">
                  {participantesNewFiltrados.length > 0 ? (
                    participantesNewFiltrados.map(p => (
                      <div key={p.id} className="modal-item">
                        <div className="modal-item-info">
                          <div className="avatar small">{getInitials(p.nome)}</div>
                          <span>{p.nome}</span>
                        </div>
                        <button
                          onClick={() =>
                            handleAddParticipante(p.id, entidadeAtiva.id)
                          }
                        >
                          Adicionar
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="no-results-modal">
                      {filtroNovosMembros ? "Nenhum usuário encontrado" : "Nenhum usuário disponível"}
                    </div>
                  )}
                </div>
              </div>

              <button className="close-btn" onClick={() => setShowGroupModal(false)}>
                Fechar
              </button>
            </div>
          </div>
        )}

        <section className="chat-messages">
          {messages.map(msg => (
            <div
              key={msg.id}
              className={`message ${msg.author}`}
            >
              <div className="bubble">
                <span className="message-text">{msg.text}</span>
                <span className="message-date">{formatDateTime(msg.data)}</span>
              </div>
            </div>
          ))}
          <div ref={endRef} />
        </section>

        <footer className="chat-input">
          <textarea
            placeholder={
              !entidadeAtiva
                ? "Selecione uma conversa"
                : entidadeAtiva.tipo === "grupo" && roleGrupo !== "ADMIN"
                ? "Apenas administradores podem enviar mensagens"
                : "Digite sua mensagem…"
            }
            value={input}
            disabled={!entidadeAtiva || (entidadeAtiva.tipo === "grupo" && roleGrupo !== "ADMIN")}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sendMessage();
              }
            }}
          />

          <button 
            onClick={sendMessage} 
            disabled={!entidadeAtiva || (entidadeAtiva.tipo === "grupo" && roleGrupo !== "ADMIN")}
          >
            Enviar
          </button>
        </footer>
      </main>
    </div>
  );
}